import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/aeroport/Transferts-aeroports-heliports.png";

const aeroport: ChauffeurPage = {
  slug: "aeroport",
  title: "Chauffeur aéroport – Transferts VTC",
  subtitle: "Prise en charge à Cannes, suivi de vol et accueil personnalisé.",
  keywords: ["chauffeur aéroport", "VTC aéroport", "transfert aéroport"],
  hero: {
    title: "Transferts aéroports & héliports",
    subtitle:
      "Depuis/vers Cannes: Nice, Monaco, Marseille – accueil pancarte & aide bagages.",
    keywords: ["suivi de vol", "accueil dédié", "forfaits clairs"],
    imageSrc: heroImage.src,
    imageAlt: "Transferts aéroports & héliports",
    badges: ["Suivi de vol", "Accueil pancarte", "Tarifs forfaitaires"],
  },
  benefits: {
    heading: "Pourquoi choisir nos transferts aéroport",
    items: [
      {
        title: "Suivi de vol",
        description:
          "Nous ajustons l’heure de prise en charge en cas de retard.",
      },
      {
        title: "Accueil avec pancarte",
        description:
          "Point de rendez-vous clair, accompagnement jusqu’au véhicule.",
      },
      {
        title: "Tarifs forfaitaires",
        description: "Prix connus à l’avance, sans surprise.",
      },
    ],
  },
  services: {
    heading: "Lignes & liaisons",
    services: [
      {
        title: "Aéroport Nice (NCE)",
        text: "Depuis Cannes: Monaco, Antibes, Saint‑Tropez.",
      },
      {
        title: "Aéroport Marseille (MRS)",
        text: "Liaisons Côte d’Azur et Provence.",
      },
      { title: "Aéroport Toulon (TLN)", text: "Var & littoral." },
      {
        title: "Aéroport Milan Malpensa (MXP)",
        text: "Trajets longue distance vers la Lombardie sur demande.",
      },
      { title: "Héliport Monaco", text: "Connexions rapides et discrètes." },
    ],
  },
  locations: {
    heading: "Points desservis",
    items: [
      { name: "Nice Aéroport" },
      { name: "Marseille Provence" },
      { name: "Toulon Hyères" },
      { name: "Monaco Héliport" },
      { name: "Cannes Mandelieu" },
      { name: "Milan Malpensa" },
      { name: "Riviera italienne" },
    ],
  },
  generic: {
    heading: "Arrivez serein à Cannes",
    subheading: "Nous nous chargeons de tout: suivi, accueil, orientation.",
    paragraphs: [
      "Votre chauffeur suit votre vol, vous attend au point convenu et vous accompagne jusqu'au véhicule.",
      "Le service aéroport est concu pour limiter l'incertitude: point de rencontre clair, marge de retard anticipée et itinéraire adapté au trafic.",
      "Nous couvrons les principaux aéroports régionaux, les héliports et des extensions sur demande vers la Riviera italienne et Milan.",
    ],
    bullets: ["Pancarte nominative", "Aide bagages", "Temps d’attente inclus"],
  },
  process: {
    heading: "Prise en charge aéroport en pratique",
    steps: [
      "Transmission des details de vol et du terminal.",
      "Mise en place du suivi de vol et du timing d'arrivée.",
      "Accueil personnalisé au point convenu.",
      "Trajet optimisé vers votre destination finale.",
    ],
  },
  faq: [
    {
      q: "Comment gérer une arrivée avec retard important ?",
      a: "Le suivi de vol permet d'ajuster automatiquement la prise en charge selon l'heure réelle d'atterrissage.",
    },
    {
      q: "Pouvez-vous assurer un transfert de nuit ou tres tot le matin ?",
      a: "Oui, selon disponibilité, nous couvrons les horaires étendus sur les lignes aéroportaires.",
    },
    {
      q: "Est-ce possible d'inclure un trajet longue distance après l'aéroport ?",
      a: "Oui, nous pouvons organiser des transferts longue distance vers la Côte, la Riviera italienne ou Milan.",
    },
  ],
  relatedLinks: [
    // Les quatre trajets AEROPORT a prix fixe du site. Ils existaient depuis
    // toujours et cette page — 188 impressions, position 62,1 — n'en liait
    // aucun, alors que « vtc cannes aeroport nice » pese a lui seul 208
    // impressions. Prix reels (classe E) lus dans `fixedTransfers`.
    {
      label: "Trajet Cannes Aéroport de Nice en voiture avec chauffeur",
      href: "/chauffeur/transferts/cannes-aeroport-nice",
    },
    {
      label: "Trajet Monaco Aéroport de Nice en voiture avec chauffeur",
      href: "/chauffeur/transferts/monaco-aeroport-nice",
    },
    {
      label: "Trajet Aéroport de Nice Saint-Tropez en voiture avec chauffeur",
      href: "/chauffeur/transferts/aeroport-nice-saint-tropez",
    },
    {
      label:
        "Trajet Aéroport de Nice Saint-Jean-Cap-Ferrat en voiture avec chauffeur",
      href: "/chauffeur/transferts/aeroport-nice-saint-jean-cap-ferrat",
    },
    {
      label: "Nos transferts avec chauffeur",
      href: "/chauffeur/transferts",
    },
    {
      label: "Voiture avec chauffeur sur la Côte d’Azur",
      href: "/chauffeur/cote-d-azur",
    },
    { label: "Faire une demande de réservation", href: "/reservation" },
  ],
  cta: {
    title: "Réserver votre transfert aéroport",
    text: "Confirmez votre arrivée à Cannes en quelques secondes.",
    primaryHref: "/reservation",
    primaryLabel: "Réserver",
  },
  seo: {
    title: "Chauffeur aéroport de Nice — Cannes dès 100 €",
    description:
      "Transfert privé depuis l'aéroport de Nice : Cannes dès 100 €, Monaco 150 €, Saint-Tropez 300 €. Suivi de vol, accueil pancarte, prix fixe au devis.",
    canonical: "/chauffeur/aeroport",
  },
};

export default aeroport;
